import { ComponentFactory } from "@encoway/react-configurator"

import * as CUI from "./bundle"
import { ComponentName } from "./constants"
import de from "./translations_de.json"
import en from "./translations_en.json"

export * from "./bundle"
export * from "./constants"
export { Theme } from "./theme"
export * from "./countNotReadyChildren"
export * as Validation from "./validation"
export * as HelperFunctions from "./helperFunctions"
export * from "./index.types"

export const translations = {
    de,
    en
}

export function override(name: string, component: any) {
    ComponentFactory.register(name, component)
    return { override } // needed to override more than one component
}

export function registerDefaultConfiguratorComponents() {
    // Handle inconsistent namings
    ComponentFactory.addAlias("tabs", ComponentName.DummyViewport)
    ComponentFactory.addAlias("selectBox", ComponentName.Dropdown)
    ComponentFactory.addAlias("readOnlyInputField", ComponentName.DisplayOnly)

    // legacy gui model stuff
    ComponentFactory.addAlias("crm,default.kly", ComponentName.Tabs)
    ComponentFactory.addAlias("crm,paging.kly", ComponentName.Section)
    ComponentFactory.addAlias(
        "parameter,label_dynamic_pair.kly",
        ComponentName.DisplayOnly
    )
    ComponentFactory.addAlias(
        "master_viewport_layout_tabbed_pane_main.kly",
        ComponentName.Tabs
    )
    ComponentFactory.addAlias(
        "master_viewport_layout_tabbed_pane_traffic_light_main.kly",
        ComponentName.Tabs
    )
    ComponentFactory.addAlias(
        ComponentName.StructureViewport,
        ComponentName.Section
    )
    ComponentFactory.addAlias(ComponentName.DummyViewport, ComponentName.Root)

    // structural components
    ComponentFactory.register(ComponentName.Root, CUI.Root)
    ComponentFactory.register(ComponentName.LinkedTree, CUI.LinkedTree)
    ComponentFactory.register(ComponentName.Section, CUI.Section)
    ComponentFactory.register(ComponentName.Tabs, CUI.Tabs)
    ComponentFactory.register(ComponentName.TabsFooter, CUI.TabsFooter)

    // helping components
    ComponentFactory.register(ComponentName.Epri, CUI.Epri)
    ComponentFactory.register(ComponentName.ErrorViewport, CUI.ErrorDialog)
    ComponentFactory.register(ComponentName.Hidden, CUI.Hidden)
    ComponentFactory.register(ComponentName.InfoButton, CUI.InfoButton)
    ComponentFactory.register(ComponentName.Message, CUI.Message)
    ComponentFactory.register(ComponentName.NotReadyCount, CUI.NotReadyCount)
    ComponentFactory.register(ComponentName.Quantity, CUI.Quantity)
    ComponentFactory.register(ComponentName.StateIcon, CUI.StateIcon)
    ComponentFactory.register(ComponentName.Tab, CUI.Tab)
    ComponentFactory.register(ComponentName.TabButton, CUI.TabButton)
    ComponentFactory.register(ComponentName.TabsList, CUI.TabsList)

    ComponentFactory.register(ComponentName.Label, CUI.Display)
    ComponentFactory.register(ComponentName.Price, CUI.Price)
    ComponentFactory.register(
        ComponentName.OptionalPositionDisplay,
        CUI.OptionalPositionDisplay
    )

    ComponentFactory.register(ComponentName.Spinner, CUI.Spinner)
    // Studio Widgets
    ComponentFactory.register(ComponentName.BurgerMenu, CUI.BurgerMenu)
    ComponentFactory.register(ComponentName.Checkbox, CUI.Checkbox)
    ComponentFactory.register(ComponentName.DisplayOnly, CUI.Display)
    ComponentFactory.register(ComponentName.Dropdown, CUI.Dropdown)
    ComponentFactory.register(ComponentName.FilterDropdown, CUI.FilterDropdown)
    ComponentFactory.register(ComponentName.DetailButton, CUI.DetailButton)
    ComponentFactory.register(ComponentName.DetailDropdown, CUI.DetailDropdown)
    ComponentFactory.register(ComponentName.ImageButton, CUI.ImageButton)
    ComponentFactory.register(ComponentName.InputField, CUI.InputField)
    ComponentFactory.register(ComponentName.Parameter, CUI.Parameter)
    ComponentFactory.register(ComponentName.RadioButton, CUI.RadioButton)
    ComponentFactory.register(ComponentName.TextButton, CUI.TextButton)

    // SAP
    ComponentFactory.register(
        ComponentName.AdditionalValue,
        CUI.AdditionalValue
    )
    ComponentFactory.register(
        ComponentName.MultiValueCheckbox,
        CUI.MultiValueCheckbox
    )

    return { override }
}
